module.exports = __webpack_public_path__ + "static/img/no-data.ac267d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/no-data.png
// module id = /a04
// module chunks = 1